<!-- Hero Section -->
<section class="hero">
    <div class="overlay">
        <img src="../../../assets/img/slides img/piston-air-compressor.jpeg" height="60%" width="80%s" alt="">
        <h1>Piston Compressors</h1>
        <a href="#product-info" class="btn-primary">Learn More</a>
    </div>
</section>

<!-- Carousel with Enhanced Design -->
<div class="carousel-container">
    <div id="compressorCarousel" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
            <div class="carousel-item active">
                <img src="../../../assets/img/active-product/animationproduct7.webp" class="d-block w-100" alt="Compressor Image">
            </div>
            <!-- Add more carousel items -->
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#compressorCarousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#compressorCarousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
        </button>
    </div>
</div>

<!-- Product Features Section with Animation -->
<section id="product-info">
    <h2 style="text-align: center;">Why Choose Our Compressors?</h2>
    <div class="feature-list">
        <div class="feature">
            <i class="fa fa-cogs"></i>
            <h3>High Efficiency</h3>
            <p>Our screw air compressors deliver maximum performance while reducing energy consumption.</p>
        </div>
        <div class="feature">
            <i class="fa-solid fa-file"></i>
            <h3>Low Maintenance</h3>
            <p>With a robust design, our compressors need minimal upkeep, lowering your operating costs.</p>
        </div>
        <!-- Add more feature blocks -->
    </div>
</section>

<!-- Contact Section -->
<section class="contact-section">
    <h2>Contact Us Today</h2>
    <p>For inquiries, support, or product demos, feel free to reach out to us.</p>
    <div class="contact-buttons">
        <a href="tel:8489359948" class="btn-contact">Call Now</a>
        <a href="mailto:rvproduction2017@gmail.com" class="btn-contact">Email Us</a>
        <a href="https://wa.me/8489359948" class="btn-contact">WhatsApp</a>
    </div>
</section>

